import Image from "next/image";
import styles from "./HearOAEHero.module.scss";
import WantMoreInfo from "@/components/forms/want-more-info";
import { form } from "@/components/forms/styles/get-in-touch";
import classNames from "classnames";
import { useState } from "react";
import { IoMdClose } from "react-icons/io";
import { useModal } from "hooks/useModal";
const IMAGE_SCALE = 0.5;

export const HearOAEHero: React.FC = () => {
  const [formOpen, setFormOpen] = useState(false);
  const toggleForm = () => setFormOpen(!formOpen);
  const { modal, open } = useModal({
    content: () => {
      return (
        <WantMoreInfo
          translationPrefix="hearoae"
          formId="mhealth-header-form"
          formClassName="GA4-LeadConversion"
          className={styles.moreInfoForm}
          message={true}
          leadSourceUTMCampaign="hearOAE launch"
          hearXProductMulti="hearOAE"
        />
      );
    },
  });

  return (
    <div
      className={classNames(
        styles.root,
        formOpen ? styles.formOpen : styles.formClosed
      )}
    >
      <div className={styles.container}>
        <div className={styles.left}>
          <img
            className={styles.logo}
            src="/assets/images/pages/hearoae/hearOAE_logo_light.svg"
            alt="hearOAE Logo"
          />
          <div className={styles.supheader}>NEXTGEN OAE TESTING</div>
          <h1>DIGITAL PRECISION, EFFORTLESS SIMPLICITY</h1>
          <div className={styles.subheader}>hearOAE is FDA cleared</div>

          <button onClick={open} className={styles.button}>
            Place your pre-order
          </button>
        </div>
        <div className={styles.right}>
          <WantMoreInfo
            translationPrefix="hearoae"
            formId="mhealth-header-form"
            formClassName="GA4-LeadConversion"
            className={styles.moreInfoForm}
            message={true}
            leadSourceUTMCampaign="hearOAE launch"
            hearXProductMulti="hearOAE"
          />
        </div>
        {modal}
      </div>
      <div className={styles.banner}>
        <div className={styles.new}>New OAE device</div>
        <div>available from</div>
        <div>$1,600</div>
      </div>
    </div>
  );
};
